import React, { useCallback } from 'react'
import { Button, ButtonProps, useModal, connectorLocalStorageKey } from '@pancakeswap-libs/uikit'
import { AbstractConnector } from '@web3-react/abstract-connector'
import useI18n from 'hooks/useI18n'
import useWalletActivate from 'hooks/useWalletActivate'
import WalletModal from 'components/WalletModal'
import { setLastWalletId } from 'connectors/lastWallet'

const UnlockButton: React.FC<ButtonProps> = (props) => {
  const TranslateString = useI18n()
  const activate = useWalletActivate()

  const handleConnect = useCallback(
    (connector: AbstractConnector, walletId: string) => {
      // Remember the exact wallet so the next visit reconnects to it rather than to
      // whichever extension currently owns `window.ethereum`.
      setLastWalletId(walletId)
      // Kept in sync so the UIKit's own eager-connect check still sees a signed-in flag.
      window.localStorage.setItem(connectorLocalStorageKey, walletId)
      activate(connector)
    },
    [activate]
  )

  const [onPresentConnectModal] = useModal(<WalletModal onConnect={handleConnect} />)

  return (
    <Button onClick={onPresentConnectModal} {...props}>
      {TranslateString(292, 'Unlock Wallet')}
    </Button>
  )
}

export default UnlockButton
